import React from "react";

/** Off-screen mount for react-to-print. */
const ThermalPrintHost = ({ data, printRef, component: Component }) => {
  if (!data || !Component) return null;
  return (
    <div
      aria-hidden
      className="fixed pointer-events-none opacity-0"
      style={{ left: -10000, top: 0 }}
    >
      <Component ref={printRef} data={data} />
    </div>
  );
};

export default ThermalPrintHost;
